import { useRouter } from 'next/router';

import { Product } from 'models/Product';

import { useSWRGet } from 'hooks/useSWRGet';

import { sendToErrorTracking } from 'utils/sendToErrorTracking';

export const useGetProductBySlug = (slug?: string) => {
  const { push } = useRouter();
  const { data, error } = useSWRGet<Product>(slug && `/product/${slug}`);

  if (error) {
    sendToErrorTracking({
      error: error,
      where: 'useGetProductBySlug#useSWRGet.error',
      context: {
        productSlug: slug,
      },
    });

    push('/500');
  }

  return { data };
};
